<template>
  <highcharts :options="chartOptions"></highcharts>
</template>

<script>
import Highcharts from 'highcharts'
import HighchartsDataModule from 'highcharts/modules/data'
import { Chart } from 'highcharts-vue'

import { translation } from '../translations-highcharts.js'

HighchartsDataModule(Highcharts)

export default {
  name: 'LikertChart',
  props: {
    title: String,
    data: Array,
    region: Object,
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      width: window.innerWidth,
    }
  },
  created() {
    window.addEventListener('resize', this.setWindowDimensions);
    Highcharts.setOptions(translation[this.lang]);
  },
  unmounted() {
    window.removeEventListener('resize', this.setWindowDimensions);
  },
  computed: {
    height() {
      return this.region ? 480 : 650;
    },
    subtitle() {
      if (this.region) {
        console.log(this.region);
        const name = this.region.loc;
        return `Näin uudet aluevaltuutetut vastasivat Ylen vaalikoneeseen ${ name }`;
      }
      else return 'Näin uudet aluevaltuutetut vastasivat Ylen vaalikoneeseen';
    },
    chartOptions() {
      return {
        chart: {
          height: this.height,
          type: 'bar',
          spacing: [10, 10, 10, 10],
          style: {
            fontFamily: 'Open Sans, sans-serif',
          },
        },
        colors: ['rgb(255, 141, 52)', 'rgba(255, 141, 52, 0.5)', 'rgba(2, 180, 200, .5)', 'rgb(2, 180, 200)'],
        data: {
          columns: this.data,
          firstRowAsNames: false,
          switchRowsAndColumns: true,
        },
        series: [
          {
            name: 'Täysin eri mieltä',
          },
          {
            name: 'Jokseenkin eri mieltä',
          },
          {
            name: 'Jokseenkin samaa mieltä',
          },
          {
            name: 'Täysin samaa mieltä',
          },
        ],
        title: {
          text: this.title,
          align: 'left',
          margin: this.width > 767 ? 30 : 24,
          style: {
            fontFamily: 'Yle Black, Yle, Open Sans, sans-serif',
            fontWeight: '900',
            fontSize: this.width > 767 ? '20px' : '18px',
            lineHeight: this.width > 767 ? '28px' : '25.2px',
            margin: this.width > 767 ? '0 0 24px 0' : '0 0 16px 0',
            color: '#000',
          },
        },
        subtitle: {
          text: this.subtitle,
          align: 'left',
          style: {
            fontFamily: 'Open Sans, sans-serif',
            fontWeight: '400',
            fontSize: this.width > 767 ? '18px' : '16px',
            lineHeight: this.width > 767 ? '27px' : '24px',
            transform: 'translate(0, 5px)',
            color: '#000',
          },
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            stacking: 'percent',
          },
          series: {
            dataLabels: {
              allowOverlap: true,
              style: {
                fontSize: '14px',
                textOutline: 'none',
              },
              y: 1,
            },
            marker: {
              enabledThreshold: 4,
              radius: 8,
            },
            borderWidth: 0,
            groupPadding: 0.05,
            lineWidth: 4,
          },
        },
        legend: {
          verticalAlign: 'top',
          itemDistance: 4,
          itemStyle: {
            fontSize: '14px',
            fontWeight: 'normal',
            color: '#222',
          },
          lineHeight: 20,
          margin: 20,
          padding: 0,
          symbolPadding: 4,
          symbolRadius: 0,
          symbolWidth: 18,
        },
        tooltip: {
          shared: true,
          style: {
            color: '#222',
          },
        },
        xAxis: {
          lineWidth: 0,
          labels: {
            padding: 2,
            style: {
              fontSize: this.width > 400 ? '13px' : '10px',
              color: '#000',
            },
          },
          tickLength: 10,
          tickPixelInterval: 100,
          title: {
            enabled: false,
          },
        },
        yAxis: {
          gridLineColor: '#E6E6E6',
          gridLineWidth: 2,
          tickInterval: 25,
          reversedStacks: false,
          labels: {
            padding: 2,
            style: {
              fontSize: '15px',
              textOverflow: 'clip',
              color: '#000',
            },
          },
          plotLines: [{
            value: 50,
            width: 2,
            color: '#000',
            zIndex: 5,
          }],
          title: {
            text: 'prosenttia',
            style: {
              fontSize: '14px',
              color: '#222',
            },
          },
        },
      }
    }
  },
  methods: {
    setWindowDimensions () {
      this.width = window.innerWidth;
      console.log(window.innerWidth);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
